// removed by extract-text-webpack-plugin
module.exports = {"rightPanel":"src-components-PatientPage-Tabs-__tabs__rightPanel--21LX1 src-components-PatientPage-__styles__panel--ZcJfz","panelTabs":"src-components-PatientPage-Tabs-__tabs__panelTabs--19zKt","tab":"src-components-PatientPage-Tabs-__tabs__tab--2RJn_","active":"src-components-PatientPage-Tabs-__tabs__active--2HFRD","tabContent":"src-components-PatientPage-Tabs-__tabs__tabContent--10j1H"};


//////////////////
// WEBPACK FOOTER
// ./src/components/PatientPage/Tabs/tabs.css
// module id = 1999
// module chunks = 0